import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Button, Form, Modal, InputGroup } from 'react-bootstrap';
import { FaPlus, FaSearch, FaEdit, FaTrash } from 'react-icons/fa';
import axios from 'axios';

const GymTrainers = () => {
  const [trainers, setTrainers] = useState([]);
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ name: '', phone: '', email: '', specialization: '', salary: '' });
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    fetchTrainers();
  }, [search]);

  const fetchTrainers = async () => {
    try {
      const res = await axios.get('/api/gym/trainers', { params: { search } });
      setTrainers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await axios.put(`/api/gym/trainers/${editId}`, formData);
      } else {
        await axios.post('/api/gym/trainers', formData);
      }
      setShowModal(false);
      setFormData({ name: '', phone: '', email: '', specialization: '', salary: '' });
      setEditId(null);
      fetchTrainers();
    } catch (err) {
      console.error(err);
    }
  };

  const handleEdit = (trainer) => {
    setFormData(trainer);
    setEditId(trainer.id);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this trainer?')) {
      try {
        await axios.delete(`/api/gym/trainers/${id}`);
        fetchTrainers();
      } catch (err) {
        console.error(err);
      }
    }
  };

  return (
    <Container fluid className="py-4">
      <Row className="mb-4">
        <Col><h2>🏋️ Gym Trainers</h2></Col>
        <Col xs="auto">
          <Button variant="success" onClick={() => { setShowModal(true); setEditId(null); setFormData({ name: '', phone: '', email: '', specialization: '', salary: '' }); }}>
            <FaPlus className="me-2" /> Add Trainer
          </Button>
        </Col>
      </Row>

      <Card className="shadow-sm mb-4">
        <Card.Body>
          <InputGroup>
            <InputGroup.Text><FaSearch /></InputGroup.Text>
            <Form.Control placeholder="Search trainers..." value={search} onChange={(e) => setSearch(e.target.value)} />
          </InputGroup>
        </Card.Body>
      </Card>

      <Card className="shadow-sm">
        <Card.Body>
          <Table responsive hover>
            <thead>
              <tr>
                <th>Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Specialization</th>
                <th>Salary</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {trainers.map((trainer) => (
                <tr key={trainer.id}>
                  <td>{trainer.name}</td>
                  <td>{trainer.phone}</td>
                  <td>{trainer.email}</td>
                  <td>{trainer.specialization}</td>
                  <td>Rs. {trainer.salary}</td>
                  <td>
                    <Button variant="outline-primary" size="sm" className="me-1" onClick={() => handleEdit(trainer)}><FaEdit /></Button>
                    <Button variant="outline-danger" size="sm" onClick={() => handleDelete(trainer.id)}><FaTrash /></Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{editId ? 'Edit' : 'Add'} Trainer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control required value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Phone</Form.Label>
              <Form.Control required value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Specialization</Form.Label>
              <Form.Control value={formData.specialization} onChange={(e) => setFormData({ ...formData, specialization: e.target.value })} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Salary</Form.Label>
              <Form.Control type="number" value={formData.salary} onChange={(e) => setFormData({ ...formData, salary: e.target.value })} />
            </Form.Group>
            <Button type="submit" variant="success">Save</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default GymTrainers;
